// externals
import type { PropsWithChildren } from 'react';

// components
import { Routing } from './routing';
import { useAppRouter } from '@makemydeal/dr-sales-checkin-ui-utils';

export const RoutingWrapper: React.FC<PropsWithChildren> = () => {
    const { location, history } = useAppRouter();
    return <Routing history={history} location={location} match={undefined as any} />;
};
